import React from "react";
import {
  Box,
  Typography,
  Container,
  CircularProgress,
  Paper,
  Chip,
  Divider,
} from "@mui/material";
import Carousel from "react-material-ui-carousel";
import DOMPurify from 'dompurify';
import { useParams } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PersonIcon from "@mui/icons-material/Person";
import { useGetBlogByIdQuery } from "./api/blogsApi";

const BlogDetailPage = () => {
  const { id } = useParams();
  const { data, isLoading, isError } = useGetBlogByIdQuery(id!);

  if (isLoading) {
    return (
      <Box height="70vh" display="flex" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !data?.data) {
    return (
      <Box height="70vh" display="flex" alignItems="center" justifyContent="center">
        <Typography color="error">Failed to load blog details.</Typography>
      </Box>
    );
  }

  const { title, content, images, created_by, created_at } = data.data;

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        {title}
      </Typography>

      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" mb={2}>
        <Chip
          icon={<PersonIcon />}
          label={created_by}
          variant="outlined"
        />
        <Chip
          icon={<CalendarMonthIcon />}
          label={new Date(created_at).toLocaleDateString()}
          variant="outlined"
        />
      </Box>

      {images?.length > 0 && (
        <Carousel
          indicators
          navButtonsAlwaysVisible
          animation="slide"
          interval={5000}
        >
          {images.map((imgUrl:any, idx:any) => (
            <Box
              key={idx}
              component="img"
              src={imgUrl}
              alt={`Slide ${idx + 1}`}
              sx={{
                width: "100%",
                maxHeight: 300,
                objectFit: "cover",
                borderRadius: 2,
              }}
            />
          ))}
        </Carousel>
      )}

      <Paper elevation={3} sx={{ p: 3, mt: 4 }}>
<Typography 
  variant="body1" 
  component="div" 
  sx={{ 
    whiteSpace: "pre-line", 
    lineHeight: 1.7,
    '& img': { maxWidth: '100%' }, // Ensure images are responsive
    '& p': { marginBottom: '1em' }, // Add spacing between paragraphs
    '& ul, & ol': { paddingLeft: '2em' } // Proper list indentation
  }}
  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
/>
      </Paper>

      <Divider sx={{ my: 5 }} />
    </Container>
  );
};

export default BlogDetailPage;
